export default "__VITE_ASSET__d8sk0FEd__"